import React from 'react';
import styled, { css } from 'styled-components';
import Check from 'utils/images/check.svg';

const CheckboxStyles = styled.div`
  ${props => (props.tall ? '41px' : '30px')};
  height: ${props => (props.tall ? '41px' : '30px')};
  border-radius: 49px;
  background-color: white;
  border: 1px solid;
  border-color: ${props => (props.selected ? 'black' : '#DDDDDD')};
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 8px 12px;
  font-family: 'Basier Circle';
  line-height: 16px;
  font-size: 12px;
  color: black;
  max-width: max-content;
  justify-content: space-between;
  ${props =>
    props.noMargin
      ? css`
          margin: 0px !important;
        `
      : undefined}: hover {
    border-color: black;
    cursor: pointer;
  }

  ${props =>
    props.disabled &&
    css`
      opacity: 0.4;

      :hover {
        border-color: #dddddd;
        cursor: default;
      }
    `}
`;

const CheckboxInput = styled.div`
  height: 14px;
  width: 14px;
  background-color: white;
  border: 1px solid #dddddd;
  border-radius: 2px;
  margin-right: 6px !important;
  background-color: white;

  ${props =>
    props.selected &&
    css`
      border-color: black;
      background-color: black;
    `}
`;

const CheckIcon = styled.img`
  margin-left: 2px;
  margin-bottom: 3px;
`;

const Beta = styled.div`
  width: 50px;
  height: 25px;
  background: #2d235f;
  border-radius: 43px;
  font-family: Basier Circle;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 25px;
  text-align: center;
  letter-spacing: -0.2px;
  color: #e6d6fa;
  margin-left: 5px;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
`;

export function CheckboxBeta(props) {
  const label = props.label || props.value;

  return (
    <CheckboxStyles
      style={props.style}
      className={props.className}
      selected={props.isChecked}
      disabled={props.disabled}
      onClick={() =>
        props.disabled ? null : props.onSelect(props.value, !props.isChecked)
      }
      tall={props.tall}
      noMargin={props.noMargin}
    >
      <LabelContainer>
        <CheckboxInput selected={props.isChecked}>
          <CheckIcon src={Check} />
        </CheckboxInput>
        <div>{label}</div>
      </LabelContainer>
      <LabelContainer>
        <Beta>BETA</Beta>
      </LabelContainer>
    </CheckboxStyles>
  );
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/CheckboxBeta/CheckboxBeta.jsx